import { AlphaCBoxIcon } from './AlphaCBoxIcon';

/**
 * author: GreenTurtwig
 * id F7A4DF3D-18C8-4717-AD58-247CEFF7EDE3
 * name alpha-c-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-c-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetCBoxIcon = AlphaCBoxIcon;
export default AlphabetCBoxIcon